'use client'; // 错误组件必须是客户端组件

import { useEffect } from 'react';
import { Button } from '@/components/ui/platejs/button'; // 假设你有一个按钮组件

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // 你可以在这里将错误信息记录到日志服务
    console.error(error);
  }, [error]);

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <h2 className="text-2xl font-bold">糟糕，出现了一些问题！</h2>
      <p className="my-4 text-muted-foreground">
        {error.message || '一个未知的错误发生了。'}
      </p>
      <Button
        onClick={
          // 尝试通过重新渲染路由段来恢复
          () => reset()
        }
      >
        再试一次
      </Button>
    </div>
  );
}